import jsxTemplate from './NavigationTemplate.jsx';
import rootNavigationDefinition from './root-navigation-definition';
import pdfNavigationDefinition from './pdf-navigation-definition';
import * as Permissions from '../../permissions';
import { enableds } from '../../platin';

export default function NavigationController() {
  this.jsxTemplate = jsxTemplate;
  const self = this;
  let isPdfUser = false;
  const VALID_ROLES_FOR_NCCH_REPORTS = ['FEPCDB', 'FESUDB', 'FEMGDB'];
  const VALID_ROLES_FOR_DECOUMENTS = ['FEPRDE', 'FEPRDB', 'FEMGDB', 'FEKIDB', 'FEPCDB'];
  const ROLES_FOR_OLD_PIF = ['ELPRDB', 'ELPRDR', 'ELMGDR', 'ELMGDB', 'FEPRDB', 'FEPRDR', 'FEMGDB', 'FEPCDB', 'FEMGDR', 'FEKIDB', 'FESUDB'];

  self.parameters = {
    light: 'casurl',
  };
  self.canRemoveEvents = false;
  self.permissions = {
    light: `${Permissions.LIGHT_ELSA},${Permissions.LIGHT_INFORMATION_MENU},${Permissions.LIGHT_REPORTS_MENU},${Permissions.LIGHT_MANAGEMENT_MENU},${Permissions.LIGHT_ESO_EMPLOYEES},${Permissions.LIGHT_COOPERATING_ESOS},${Permissions.LIGHT_NC_PANEL}`,
  };

  let isSomeElActive = false;

  function getUrlHash(url) {
    const hashIndex = [...url].findIndex((el) => el === '#');
    if (hashIndex > -1) {
      return url.substring(hashIndex, url.length);
    }
    return '';
  }

  function isHrefMatch(menuData, currentHash) {
    return currentHash.includes(getUrlHash(menuData.href.split('?')[0]));
  }

  function isHighlightMatch(menuData, currentHash) {
    return (
      menuData?.highlightOn?.some((url) => currentHash.includes(getUrlHash(url.split('?')[0]))) || false
    );
  }

  // Dopasowanie do całego URL (nie tylko części po #)
  function isHighlightPatternMatch(menuData, currentUrl) {
    return menuData?.highlightOnPattern?.some((pattern) => currentUrl.includes(pattern)) || false;
  }

  // Sprawdza, czy w całym drzewie menu istnieje jakiekolwiek trafienie po highlightOnPattern
  function hasAnyHighlightPatternMatch(menuData, currentUrl) {
    if (Array.isArray(menuData)) {
      return menuData.some((el) => hasAnyHighlightPatternMatch(el, currentUrl));
    }
    if (menuData.children) {
      return hasAnyHighlightPatternMatch(menuData.children, currentUrl);
    }
    return isHighlightPatternMatch(menuData, currentUrl);
  }

  function findActiveElement(menuData, patternHasPriority) {
    if (Array.isArray(menuData)) {
      menuData.forEach((el) => findActiveElement(el, patternHasPriority));
      return menuData.some((el) => el.active);
    }

    const currentHash = window.location.hash;
    const currentUrl = window.location.href;
    let isActive;

    if (!Object.hasOwn(menuData, 'available')) {
      menuData.available = true;
    }
    if (menuData.children) {
      isActive = findActiveElement(menuData.children, patternHasPriority);
      menuData.active = isActive;
      if (isActive) isSomeElActive = true;
    } else if (patternHasPriority) {
      // Priorytet: aktywne tylko elementy pasujące przez highlightOnPattern
      isActive = isHighlightPatternMatch(menuData, currentUrl);
      menuData.active = isActive;
      if (isActive) isSomeElActive = true;
    } else {
      isActive = isHrefMatch(menuData, currentHash) || isHighlightMatch(menuData, currentHash);
      menuData.active = isActive;
      if (isActive) isSomeElActive = true;
    }
    return false;
  }

  function onLogoutButtonClick() {
    self.app.clearSession();
    window.location = `${self.getParameter.light.casurl}/logout?service=${encodeURIComponent(
      self.app.getLogoutPageUrl(),
    )}`;
  }

  function userHasPermission(permission) {
    return self.hasPermissionTo.light[permission];
  }

  function getMainMenu(obj) {
    return isPdfUser ? pdfNavigationDefinition(obj) : rootNavigationDefinition(obj);
  }

  function shouldShowReportsInNavigation(roles) {
    if (!enableds.showReportsInMainMenu) {
      return false;
    }
    return roles.some((role) => VALID_ROLES_FOR_NCCH_REPORTS.includes(role));
  }

  self.init = async function init() {
    const { showExtendedContext } = await self.app.context.currentEmployee.getMe();
    const { roles } = self.app.context.currentEmployee.getSubject();
    const ncchReporstAvailable = shouldShowReportsInNavigation(roles);
    const documentsAvailable = roles.some((role) => VALID_ROLES_FOR_DECOUMENTS.includes(role));
    const oldPifAvailable = roles.some((role) => ROLES_FOR_OLD_PIF.includes(role));

    isPdfUser = window.location.hash.includes('#pdf');
    self.menuItems = getMainMenu({ userHasPermission, showExtendedContext, ncchReporstAvailable, documentsAvailable, oldPifAvailable });
    window.addEventListener('hashchange', () => {
      const ncchReporstAvailable = shouldShowReportsInNavigation(roles);
      isPdfUser = window.location.hash.includes('#pdf');
      self.menuItems = getMainMenu({ userHasPermission, showExtendedContext, ncchReporstAvailable, documentsAvailable, oldPifAvailable });

      isSomeElActive = false;
      const patternHasPriority = hasAnyHighlightPatternMatch(self.menuItems, window.location.href);
      findActiveElement(self.menuItems, patternHasPriority);

      if (!isSomeElActive) {
        self.menuItems[0].active = true;
      }

      self.render();
    });

    const patternHasPriority = hasAnyHighlightPatternMatch(self.menuItems, window.location.href);
    findActiveElement(self.menuItems, patternHasPriority);

    if (!isSomeElActive) {
      self.menuItems[0].active = true;
    }

    self.render();
  };

  self.events = {
    '#logoutButtonId click': onLogoutButtonClick,
  };
}
